// extracted by mini-css-extract-plugin
export default {"header":"ChartBox_header__aiVic","title":"ChartBox_title__DnWlT","subtitle":"ChartBox_subtitle__iV5cN","content":"ChartBox_content__Ze4Cz","wrapper":"ChartBox_wrapper__Psu1i"};